.ap-stats {
    padding: 0px 10px;
    background-color: #f5f5f5;
}

.ap-dialog-container .ap-container,
.ap-aui-dialog2 div {
    height: 100%;
}

.ap-aui-dialog2 div.ap-stats {
    height: auto;
    position: absolute; /* go over the top of the bottom bar when visible */
}

/* add new aui dialog size of fullscreen */
.ap-aui-dialog2.aui-dialog2-fullscreen {
    /*
    https://jira.atlassian.com/browse/CONFCLOUD-73967
    We couldn't find how this issue started happening, it might have been there for some time but noone noticed it before.
    Adding !important to increase priority of this over .aui-dialog2.aui-layer
    */
    top: 0 !important;
}

/* add new aui dialog size of maximum */
.ap-aui-dialog2.aui-dialog2-maximum {
    top: 0 !important;
    height: 100%;
}
.ap-aui-dialog2.aui-dialog2-maximum .aui-dialog2-content {
    height: 100%;
}

.ap-aui-dialog2 .aui-dialog2-content {
  padding:0;

    /* in chrome'd dialogs - fixes scrollbars added by iframes with scrollbars pushing the width out */
    overflow:hidden;

    /* in safari, chromeless dialogs become invisible, because apparently GPU FTW */
    -webkit-transform: translatez(0);
    will-change: opacity, visibility;

    display: flex;
    flex-direction: column;
}

.ap-aui-dialog2 iframe {
    display:block;
}

.ap-aui-dialog2.aui-dialog2-chromeless .aui-dialog2-content {
    background-color:transparent;

    /* Override the aui selector that assumes the last-child is the footer */
    border-radius: 0;
}

.ap-aui-dialog2 .ap-status-indicator {
  padding: 5px 10px;
  background: transparent;
  position: absolute;
  top: 10px;
  width: 100%;
}

.ap-aui-dialog2.aui-dialog2-maximum .ap-status-indicator,
.ap-aui-dialog2.aui-dialog2-chromeless .ap-status-indicator {
  display: none;
}

.ap-aui-dialog2 .ap-stats {
  display: block;
}

/* header controls */
/*
   These styles lifted from the file viewer. We could conceivably define a separate component 'header-controls'
   in AUI that contains its own styles, but adding to AUI is out of scope for the current task.

   Given that plugin devs won't be working directly with these CSS rules, we have some flexibility to refactor
   these internals later.
 */

.ap-header-controls.aui-dialog2 .aui-dialog2-header {
    background-color: #000;
    border-radius: 0;
    height: 50px;
    margin-top: 0;
    padding: 0 0 0 20px;
}

.ap-header-controls .header-title-container {
    max-width: 70%;
    display: block;
    float: left;
    height: 50px
}

.ap-header-controls .header-title-container div {
    color: #fff;
    line-height: 50px;
    white-space: nowrap;
    overflow: hidden
}

.ap-header-controls .header-control-panel {
    padding-left: 0;
    text-align: right;
    float: right;
    max-width: 30%;
    display: block;
    height: 50px
}

.ap-header-controls .header-control-panel > span {
    display: inline-block
}

.ap-header-controls .header-control-panel .aui-button {
    background-color: #000;  /* Override blue for primary controls*/
    background-position: center;
    background-repeat: no-repeat;
    border-left: 1px solid #333;
    border-radius: 0px;
    height: 50px;
    float: left;
    margin-left: 0;  /* overrides AUI style of 10px */
    text-align: left;
    text-indent: -999em;
    width: 50px
}

/* Pads the button icons provided by the AUI Icon font */
.ap-header-controls .header-control-panel .aui-icon-small:before {
    color: #fff;
    margin-left: 16px;
}

/* Reduce the height of the content div to allow for the height of the header bar */
.ap-header-controls .aui-dialog2-content {
    max-height: calc(100% - 50px);
}
.ac-flag-actions a {
  margin-right: 10px;
  /* whole flag text appears on 1 line */
  display: inline-block;
}
.ap-status-indicator {
  padding-top: 5px;
  font-size: 12px;
  line-height: 1.42857142857143;
}

.ap-status-indicator small {
  color: #707070;
}

.ap-loading, .ap-load-timeout {
  padding-left: 4px;
}

.ap-link-disabled, .ap-link-disabled:hover, .ap-link-disabled:visited, .ap-link-disabled:focus {
  color: gray !important;
  text-decoration: none;
}

.ap-iframe-container iframe {
  border: 0;
}

.ap-iframe-container iframe.full-size-general-page {
  border-bottom: 1px solid #ccc;
}
.ap-iframe-container iframe.full-size-general-page-no-footer {
  border:none;
}

iframe.sized-to-parent {
  display: block;
}

.ap-status-indicator .small-spinner {
  width: 20px;
  height: 20px;
  float: left;
  margin-right: 4px;
}

.ap-iframe-container {
  line-height: 0;
  margin: 0;
  padding: 0;
  font-size: 0;
}

@-webkit-keyframes fadeInConnectSpinner { from { opacity: 0; } to { opacity: 1; } }
@-moz-keyframes fadeInConnectSpinner { from { opacity: 0; } to { opacity: 1; } }
@-o-keyframes fadeInConnectSpinner { from { opacity: 0; } to { opacity: 1; } }
@keyframes fadeInConnectSpinner { from { opacity: 0; } to { opacity: 1; } }

.ap-status-indicator {
  opacity: 0;
  animation: fadeInConnectSpinner 0.5s ease-in;
  animation-delay: 1s;
  animation-fill-mode: forwards;
}

.connect-resolve-error {
  font-size: 12px;
  line-height: 1.42857142857143;  
}
#ac-message-container {
	top: 20px;
	left: 50%;
	max-width: 600px;
	position: fixed;
	z-index: 4000;
}

.ap-aui-message {
  font-size: 14px;
  margin: 10px;
}